/**
 * Recent wins panel for the home view per spec section 15.10. Lists
 * opportunities that landed in the WON column in the last 7 days.
 */

import type { WireRecentWin } from '@/lib/api/sales';
import { useSlideOver } from '@/lib/slide-over';

interface RecentWinsProps {
  wins: WireRecentWin[];
}

export function RecentWins({ wins }: RecentWinsProps) {
  const openSlideOver = useSlideOver((s) => s.open);
  return (
    <section className="border border-mx-grey-800 bg-mx-card p-mx-4">
      <p className="mono-label text-mx-grey-mid">
        <span className="num">04</span>
        Recent wins
      </p>
      {wins.length === 0 ? (
        <p className="mt-mx-3 text-mx-body-sm text-mx-grey-mid">
          No opportunities won in the last 7 days.
        </p>
      ) : (
        <ul className="mt-mx-3 flex flex-col">
          {wins.map((win) => (
            <li key={win.id} className="border-t border-mx-grey-800 first:border-t-0">
              <button
                type="button"
                onClick={() => openSlideOver({ kind: 'opportunity', opportunityId: win.id })}
                className="flex w-full items-center justify-between gap-mx-3 py-mx-2 text-left"
              >
                <div className="flex flex-1 flex-col">
                  <span className="mono-label text-mx-grey-mid">{win.companyName}</span>
                  <span className="text-mx-body-sm text-mx-grey-300">{win.opportunityName}</span>
                </div>
                {win.budgetFee && (
                  <span className="tnum font-display text-mx-body-sm font-semibold text-mx-pos">
                    {formatCurrency(win.budgetFee)}
                  </span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

function formatCurrency(value: string): string {
  const num = parseFloat(value);
  if (Number.isNaN(num)) return value;
  if (num >= 1_000_000) return `$${(num / 1_000_000).toFixed(2)}M`;
  if (num >= 1_000) return `$${(num / 1_000).toFixed(0)}K`;
  return `$${num.toFixed(0)}`;
}
